import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IValueLabel} from "../../../variables/types/IValueLabel";
import {getTinderMultiLeadInvestmentRows} from "./tinder_multi_lead_utils";

interface IProps {
    property: IPropertyDetail;
    variables: {
        offer_facilities?: IValueLabel[];
        offer_standard_description_type?: IValueLabel[];
    } | null;
}

export function TinderMultiLeadInvestmentSection({property, variables}: IProps) {
    const rows = getTinderMultiLeadInvestmentRows(property, variables);

    return (
        <section className={sectionStyle}>
            <Text variant="mini_header" as="h3" color="var(--colors-secondary)">
                Inwestycja
            </Text>

            <dl className={cardStyle}>
                {rows.map((row) => (
                    <div className={rowStyle} key={row.label}>
                        <Text variant="info_txt_1" as="dt" color="var(--colors-gray-700)" className={labelStyle}>
                            {row.label}
                        </Text>
                        <Text variant="body_copy_2" as="dd" color="var(--colors-secondary)" className={valueStyle}>
                            {row.value}
                        </Text>
                    </div>
                ))}
            </dl>
        </section>
    );
}

const sectionStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2
});

const cardStyle = css({
    m: 0
});

const rowStyle = css({
    display: "flex",
    alignItems: "flex-start",
    gap: 2,
    py: 2,
    borderBottom: "1px solid var(--colors-gray-200)",
    "&:last-of-type": {
        borderBottom: "none"
    }
});

const labelStyle = css({
    flexShrink: 0,
    flexBasis: "45%",
    maxWidth: "200px"
});

const valueStyle = css({
    flex: 1,
    minWidth: 0
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IValueLabel} from "../../../variables/types/IValueLabel";
import {getTinderMultiLeadInvestmentRows} from "./tinder_multi_lead_utils";

interface IProps {
    property: IPropertyDetail;
    variables: {
        offer_facilities?: IValueLabel[];
        offer_standard_description_type?: IValueLabel[];
    } | null;
}

export function TinderMultiLeadInvestmentSection({property, variables}: IProps) {
    const rows = getTinderMultiLeadInvestmentRows(property, variables);

    return (
        <section className={sectionStyle}>
            <Text variant="mini_header" as="h3" color="var(--colors-secondary)">
                Inwestycja
            </Text>

            <dl className={cardStyle}>
                {rows.map((row) => (
                    <div className={rowStyle} key={row.label}>
                        <Text variant="info_txt_1" as="dt" color="var(--colors-gray-700)" className={labelStyle}>
                            {row.label}
                        </Text>
                        <Text variant="body_copy_2" as="dd" color="var(--colors-secondary)" className={valueStyle}>
                            {row.value}
                        </Text>
                    </div>
                ))}
            </dl>
        </section>
    );
}

const sectionStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2
});

const cardStyle = css({
    m: 0
});

const rowStyle = css({
    display: "flex",
    alignItems: "flex-start",
    gap: 2,
    py: 2,
    borderBottom: "1px solid var(--colors-gray-200)",
    "&:last-of-type": {
        borderBottom: "none"
    }
});

const labelStyle = css({
    flexShrink: 0,
    flexBasis: "45%",
    maxWidth: "200px"
});

const valueStyle = css({
    flex: 1,
    minWidth: 0
});
